import {onDomReady} from "../../components/dynamic/observer";
import {Controller, Navigation, Pagination, Swiper} from 'swiper';
import '../../../node_modules/swiper/swiper.scss';
import RSlider from "../../components/rslider/rslider";

function init() {
    const actionsSliderContainer = document.querySelectorAll('[data-actions-slider-container]');
    if (!actionsSliderContainer) {
        return;
    }

    actionsSliderContainer.forEach((container) => {
        const actionsSliderElement = container.querySelector('[data-actions-slider]');
        if (!actionsSliderElement) {
            return;
        }

        const leftArrow = container.querySelector('[data-actions-slider-left]');
        const rightArrow = container.querySelector('[data-actions-slider-right]');
        const pagination = container.querySelector('[data-actions-slider-pagination]');

        const slider = new Swiper(actionsSliderElement, {
            modules: [Navigation, Pagination, Controller],
            slidesPerView: "auto",
            speed: 500,
            spaceBetween: 0,
            preventInteractionOnTransition: true,
            navigation: {
                prevEl: leftArrow,
                nextEl: rightArrow,
            },
            pagination: {
                el: pagination,
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                },
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                        '<span class="swiper-pagination-line" data-actions-slider-progressbar></span>' +
                        '<span class="' + totalClass + '"></span>';
                }
            },
        });

        const progressbar = new Swiper(actionsSliderElement, {
            modules: [Pagination],
            pagination: {
                el: document.querySelector('[data-actions-slider-progressbar]'),
                type: 'progressbar',
            },
        });

        slider.controller.control = progressbar;

        const textElement = container.querySelector('[data-rslider="actions-text-slider"]');
        if (!textElement) {
            console.log('Could not find any element with actions-text-slider');
            return;
        }
        const textSlider = new RSlider(
            textElement,
            {
                onStart: ({ slideIn, slideFriendsIn }) => {
                    slideFriendsIn.forEach((friendIn) => {
                        friendIn.classList.add('_active');
                    })
                    slideIn.classList.add('_active');
                },
                timeline: [
                    RSlider.action({
                        // К слайдам докидывается:
                        // К появляющемуся: --rslider-first-act-in-progress: 0.2;
                        // К исчезающему: --rslider-first-act-out-progress: 0.2;
                        // easing ниже настраивается
                        name: 'next-act',
                        duration: 500,
                        delay: 0,
                        // easeInOutCubic прогресс для "приходящего" слайда
                        // easingIn: (x) => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
                        // linear прогресс для "уходящего" слайда
                        // easingOut: (x) => x,
                        onStart: ({ slideIn, slideOut, slideFriendsIn, slideFriendsOut }) => {
                            slideIn.classList.add('_active');
                            slideOut.classList.remove('_active');

                            slideIn.classList.add('_in-next-act');
                            slideOut.classList.add('_out-next-act');

                            slideFriendsIn.forEach((friendIn) => {
                                friendIn.classList.add('_active');
                                friendIn.classList.add('_in-next-act');
                            })

                            setTimeout(() => {
                                slideIn.classList.remove('_in-next-act');

                                slideFriendsIn.forEach((friendIn) => {
                                    friendIn.classList.remove('_in-next-act');
                                })
                            }, 500);

                            slideFriendsOut.forEach((friendOut) => {
                                friendOut.classList.remove('_active');
                                friendOut.classList.add('_out-next-act');
                            })
                        },
                        onEnd: ({ slideIn, slideOut, slideFriendsIn, slideFriendsOut }) => {
                            slideOut.classList.remove('_out-next-act');

                            slideFriendsOut.forEach((friendOut) => {
                                friendOut.classList.remove('_out-next-act');
                            })
                        }
                    }),
                ],
            });

        slider.on('slideNextTransitionStart', () => {
            textSlider.next();
        });

        slider.on('slidePrevTransitionStart', () => {
            textSlider.prev();
        });
    })
}

onDomReady(init);